import { PRAGATI_ACTION, STATUS } from "../constant";

const initialState = {
  upcommingPragatiFlagData: {}
};

export default function pragati(state = initialState, action) {
  switch (action.type) {
    case PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_START:
      return { ...state, upcommingPragatiFlagStatus: STATUS.LOADING, data: [] };

    case PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_SUCCESS: {
      return {
        ...state,
        upcommingPragatiFlagData: action.data,
        //upcommingPragatiFlag: true,
        upcommingPragatiFlagStatus: STATUS.SUCCESS
      };
    }

    case PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_FAILURE:
      return { ...state, upcommingPragatiFlagStatus: STATUS.ERROR };

    default:
      return state;
  }
}
